<template>
    <div class="dashboards-filters">
      <div class="dashboards-filters">
        <strong>{{ title }}</strong>
      </div>
      <div class="dashboards-filters dashboards-filters-date date-simple">
        <date-picker
          :value="creationDate"
          format="MMM YY"
          value-type="format"
          type="month"
          :clearable="false"
          range-separator="-"
          :editable="false"
          :shortcuts="false"
          input-class="date-simple-input"
          range
          lang="en"
          class="dark"
          @input="$emit('date-change', $event)"
        ></date-picker>
      </div>

      <div class="dashboards-filters">
        <type-switcher
          v-model="params.reportType"
          :options="reportTypeList"
          />
      </div>

      <div class="dashboards-filters">
        <language-picker
          :options="languagesList"
          v-model="params.sourceLanguage"
          placeholder="Source language"
        ></language-picker>
      </div>

      <div class="dashboards-filters">
        <language-picker
          :options="languagesList"
          v-model="params.targetLanguage"
          placeholder="Target language"
        ></language-picker>
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.industry_field"
          :options="industryFieldList"
          field-name="Name"
          placeholder="Industry sector(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.doc_type"
          :options="textCategoryList"
          field-name="Name"
          placeholder="Document type(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.qaModel"
          :options="qaModelsList"
          field-name="Name"
          placeholder="QA model(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.qaMethod"
          :options="qaMethodsList"
          field-name="Name"
          placeholder="Method(s)"
        />
      </div>
    </div>
</template>

<script>
import Vue from 'vue';
import props from './props.js';

export default Vue.extend({
  name: 'OverallDashboardFilters',
  components: {
    'language-picker': () =>
      import('@/components/selectors/language/index.vue'),
    'filter-multiselect': () =>
      import('@/components/selectors/filterMultiple/index.vue'),
    'date-picker': () => import('vue2-datepicker'),
    'type-switcher': () => import('@/components/selectors/switcher/index.vue'),
  },
  props: {
    ...props,
  },
  computed: {
    params: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
});
</script>

<style lang="scss">
.vendor-trends-item-wrapper {
  margin-bottom: 50px;
}
.dashboards-filters {
  margin-bottom: 0!important;
  flex-flow: row wrap;
  height: auto!important;

  &-date {
    margin-left: 40px;
  }
}
</style>
